// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableFixHead {
  display: inline-block;
  margin-top: 1rem;
  height: 68vh;
  overflow: auto;
}

td {
  padding: 10px 5px;
  align-items: center;
  justify-content: center;
}

.table td,
.table th {
  vertical-align: middle !important;
  border-top: none !important;
}

td,
th,
thead,
tr {
  border-color: none !important;
  border-style: none !important;
  border-width: 0;
}

th,
tr {
  text-align: center;
}

thead {
  background-color: #030a1d;
  color: #ffffff;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.table-rounded {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

tbody {
  display: block;
  height: 59vh;
  overflow: scroll;
}

thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

thead > tr > th {
  word-wrap: break-word;
}

tbody > tr > td {
  overflow: scroll;
}

.rs-table-cell-header {
  color: white !important;
  font-weight: bold !important;
  font-size: 15px;
}

#header {
  background-color: #030a1d !important;
}

#content {
  font-size: 15px;
  color: black !important;
}

.rs-table-body-wheel-area {
  background-color: white !important;
}

.rs-table-scrollbar {
  width: 0px !important;
  height: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/tableComponent/table.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;;EAEE,iCAAA;EACA,2BAAA;AAFF;;AAKA;;;;EAIE,6BAAA;EACA,6BAAA;EACA,eAAA;AAFF;;AAKA;;EAEE,kBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,UAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;EACA,0CAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAIA;;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EAEE,gBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,4BAAA;EACA,eAAA;AAFF;;AAQA;EACE,oCAAA;AALF;;AAQA;EACE,eAAA;EACA,uBAAA;AALF;;AAOA;EACE,kCAAA;AAJF;;AAMA;EACE,qBAAA;EACA,sBAAA;AAHF","sourcesContent":["@import \"../../styles//sass//common.scss\";\n\n.tableFixHead {\n  display: inline-block;\n  margin-top: 1rem;\n  height: 68vh;\n  overflow: auto;\n}\n\n// th,\ntd {\n  padding: 10px 5px;\n  align-items: center;\n  justify-content: center;\n}\n\n.table td,\n.table th {\n  vertical-align: middle !important;\n  border-top: none !important;\n}\n\ntd,\nth,\nthead,\ntr {\n  border-color: none !important;\n  border-style: none !important;\n  border-width: 0;\n}\n\nth,\ntr {\n  text-align: center;\n}\n\nthead {\n  background-color: #030a1d;\n  color: #ffffff;\n}\n\n::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n\n.table-rounded {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n}\n\ntbody {\n  display: block;\n  height: 59vh;\n  overflow: scroll;\n}\nthead,\ntbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\nthead > tr > th {\n  word-wrap: break-word;\n}\n\ntbody > tr > td {\n  // word-wrap: break-word;\n  overflow: scroll;\n}\n\n.rs-table-cell-header {\n  color: white !important;\n  font-weight: bold !important;\n  font-size: 15px;\n}\n.rs-table-cell {\n  // background-color: #030a1d !important;/\n}\n\n#header {\n  background-color: #030a1d !important;\n}\n\n#content {\n  font-size: 15px;\n  color: black !important;\n}\n.rs-table-body-wheel-area {\n  background-color: white !important;\n}\n.rs-table-scrollbar {\n  width: 0px !important;\n  height: 0px !important;\n}\n// .rs-table-scrollbar-handle,\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
